
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.54 5.08A10.609 10.609 0 0011.91 2a10 10 0 10-.05 20 2.58 2.58 0 002.53-1.89 2.52 2.52 0 00-.57-2.28.5.5 0 01.37-.83h1.65A6.15 6.15 0 0022 11.33a8.48 8.48 0 00-2.46-6.25zM15.88 15h-1.65a2.49 2.49 0 00-1.87 4.15.49.49 0 01.12.49c-.05.21-.28.34-.59.36a8.001 8.001 0 01-7.82-9.11A8.1 8.1 0 0111.92 4H12a8.47 8.47 0 016.1 2.48 6.5 6.5 0 011.9 4.77A4.17 4.17 0 0115.88 15z"}}),_c('path',{attrs:{"d":"M12 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15.25 7.2a1.5 1.5 0 101.501 2.598A1.5 1.5 0 0015.25 7.2zM8.75 7.2a1.5 1.5 0 10-1.498 2.6A1.5 1.5 0 008.75 7.2zM6.16 11.26a1.5 1.5 0 102.08.4 1.49 1.49 0 00-2.08-.4z"}})])
          )
        }
      }
    